import React from "react";
import { Skeleton } from "antd";

const NovaAiLoader = ({ bottomRef }) => {
  return (
    <>
      <div className="skeleton-loader" ref={bottomRef}>
        <div className="nova-skeleton-line bot" />
        <Skeleton active className="nova-skeleton-lines" />
      </div>
    </>
  );
};

export default NovaAiLoader;
